module.exports = __webpack_public_path__ + "42df9c98b3fa042bcba671c85acc05e7.svg";